import BaseItem, { Rarity } from './base_item';

export default class FireExtinguisher extends BaseItem {
    constructor(x, y) {
        super(x, y, "items", "fire_ext.png");
    }

    //this is width/height of collision box (attached to bottom)
    static get width() { return 15;}
    static get height() { return 8;}

    static get mass() { return 2;}
    static get rarity() { return Rarity.COMMON; }
    static get electronic() { return false; }


    static get type() { return 'fire_ext'}
    static get label() { return 'Fire extinguisher'}
    static get description() { return `Fire extinguisher, mostly used to move around in zero gravity.`}
}


// WEBPACK FOOTER //
// ./src/objects/items/fire_extinguisher.js